import { ActivityItemPhoneVideoButtons } from 'Components/ActivityItemPhoneVideoButtons';
import { ActivityItemPhoneVideoButtonsProps } from 'Components/ActivityItemPhoneVideoButtons/types';
import { IconButton } from 'Components/shared/IconButton';
import { MobXProviderContext, observer } from 'mobx-react';
import * as React from 'react';
import { RootStoreProps } from 'Stores/RootStore.types';
import { isNullOrUndefined } from 'Utils/typeGuards';
import { selectProperVideoTooltipMessageForGroups } from 'Utils/videoConferenceUtils';
import { ConversationItemCallButtonsProps } from './index.types';

const ConversationItemCallButtons: React.FC<
  ConversationItemCallButtonsProps
> = ({ conversation }) => {
  const {
    config: configStore,
    conversation: conversationStore,
    person: personStore,
    ui: uiStore,
  } = React.useContext<RootStoreProps>(MobXProviderContext);

  const toggleMuteStatus = (conversationid: string): boolean => {
    const value = uiStore.selectIfConvMuted(conversationid);
    uiStore.setConvMuted(conversationid, !value);
    uiStore.setMoreActionOptions({ show: false, conversationId: '' });
    return !value;
  };

  const isOneOnOne = conversation.grouping === 'OneOnOne';

  const isVideoCallDisabled =
    !!conversationStore.LoggedInUserActiveConferenceConversation ||
    !personStore.personAvaliableFeatures.video.enabled;

  const userIsInActiveVideoConference = !isNullOrUndefined(
    conversationStore.LoggedInUserActiveConferenceConversation
  );

  const conferenceIsActive =
    !isNullOrUndefined(conversation?.activeConference) &&
    conversation?.activeConference.sessionId !== '';

  if (isOneOnOne) {
    const otherParticipant = conversation?.participants?.find(
      (participant) => participant.personId !== personStore.loggedInPersonId
    );

    if (!otherParticipant) {
      return null;
    }

    const commonProps: ActivityItemPhoneVideoButtonsProps = {
      conversation,
      buttonSize: 'small',
      grouping: 'OneOnOne',
      from: 'recentFevList',
    };

    if (otherParticipant.personId) {
      const personPbo = personStore.loadPersonByIdGetIfMissingGet(
        otherParticipant.personId.toString()
      );

      return (
        <ActivityItemPhoneVideoButtons {...commonProps} personPbo={personPbo} />
      );
    }

    if (otherParticipant.phone) {
      return (
        <ActivityItemPhoneVideoButtons
          {...commonProps}
          phone={otherParticipant.phone}
        />
      );
    }

    return null;
  }

  if (
    !isOneOnOne &&
    configStore &&
    !isVideoCallDisabled &&
    !conversation?.IsSmsConversation
  ) {
    return (
      <IconButton
        compact
        onClick={() =>
          void conversationStore.postConferenceByConversationId(
            conversation?.id
          )
        }
        content={selectProperVideoTooltipMessageForGroups(
          conferenceIsActive,
          userIsInActiveVideoConference
        )}
        disabled={{
          title: 'Video conference unavailable',
          condition:
            userIsInActiveVideoConference ||
            !personStore.personAvaliableFeatures.video.enabled,
        }}
        icon="video"
        testid={`conversationItem-buttonStartVideoCall`}
        {...{ popupPosition: 'bottom right', size: 'small' }}
      />
    );
  }

  return null;
};

export default observer(ConversationItemCallButtons);
